import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * Styled wrapper for the Communications Preferences tab
 */
export const CommunicationsPreferencesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  gap: ${sp(6)};
  background-color: ${({ theme }) => theme.colors.bgAccent};
  padding: ${sp(5)} ${sp(5)};

  ${responsive.atLeastDesktop} {
    padding: ${sp(6)} ${sp(12)};
  }
`;
